export default "__VITE_ASSET__CXNI21zO__"